module.exports = __webpack_public_path__ + "img/thumbnail-size-calculator.0022fc43.webp";